import Image from "next/image";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import { useEffect, useState } from "react";
import axios from "axios";
import { decodeHtml } from "@/utils/helpers";
import { useRouter } from "next/router";
import useWindowSize from "@/hooks/useWindowSize";
import styles from "@/styles/Questions.module.scss";
import BlogCard from "./BlogCard";
import { getStrapiMedia } from "@/utils/media";

interface ResourceProps {
  slug?: string;
  isMobile?: any;
  categories?: any[];
}
const Resources = ({ slug, categories, isMobile }: ResourceProps) => {
  const router = useRouter();
  const [blog, setBlog] = useState<any>([]);
  const [width] = useWindowSize();

  useEffect(() => {
    loadBlog();
  }, [slug]);

  useEffect(() => {
    const handleRouteChange = () => {
      window.scrollTo(0, 0); // Scrolls to the top of the page after navigation
    };

    router.events.on("routeChangeComplete", handleRouteChange);

    return () => {
      router.events.off("routeChangeComplete", handleRouteChange);
    };
  }, []);
  const loadBlog = async () => {
    let filterQuery = "";
    categories?.map((category: any, index: number) => {
      filterQuery += `&filters[Categories][Slug][$in][${index}]=${category?.attributes?.Slug}`;
    });
    await axios
      .get(
        `${process.env.NEXT_PUBLIC_STRAPI_API_URL
        }/api/posts?populate=*&sort[5]=Date:desc&pagination[pageSize]=5${categories?.length ? filterQuery : ""
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
          },
        }
      )
      .then((res) => {
        if (res?.data?.data?.length >= 5) setBlog(res?.data?.data);
        else loadMoreBlog(res?.data?.data);
      });
  };
  const loadMoreBlog = async (data: []) => {
    await axios
      .get(
        `${process.env.NEXT_PUBLIC_STRAPI_API_URL
        }/api/posts?populate=*&sort[5]=Date:desc&pagination[pageSize]=${5 - data.length
        }`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_API_TOKEN}`,
          },
        }
      )
      .then((res) => {
        setBlog([...data, ...res?.data?.data]);
      });
  };

  return blog?.length > 0 ? (
    <div className={styles.res}><Container className="margin-x pt-44" fluid>
      <h2 className="mb-24 h2-res">Resources</h2>
      <Row className="row-class equal-height-cards">
        <Col lg={5} md={12} className=" pointer pl-3 p-0" onClick={(e) => {
          e.preventDefault()
          if (e?.ctrlKey)
            window.open(`/resources/blog/${blog[0]?.attributes?.Slug}`, '_blank')
          else
            router.push(`/resources/blog/${blog[0]?.attributes?.Slug}`)
          // .then(() => {
          //     window.scrollTo(0, 0); // Scrolls to the top of the page after navigation
          //   });
        }
        }>
          {width > 1129 ? (
            <a
              href={`/resources/blog/${blog[0]?.attributes?.Slug}`}
              target="_blank"
              rel="noopener noreferrer"
              className="text-decoration-none"
              onContextMenu={(e) => {
                e.stopPropagation(); // Allow the default browser context menu
              }}
            >
              <Card className={`h-100 card-first ${styles.buttonAnimate}`}>
                <div className="w-100"><Image
                  src={
                    getStrapiMedia(blog[0]?.attributes?.Banner || blog[0]?.attributes?.BannerThumb) || blog[0]?.attributes?.BannerImageURL || "/assets/images/blog-common.jpg"
                  }
                  alt={blog[0]?.attributes?.alternativeText || "technologies"}
                  // style={{ objectFit: "contain", objectPosition: "center center",minWidth:"490px", minHeight:"400px"}}
                  className="img-fluid blog-first"
                  height={
                    blog?.[0]?.attributes?.Banner?.data?.attributes?.height || 400
                  }
                  width={
                    blog?.[0]?.Banner?.data?.attributes?.attributes?.width || 600
                  }
                />
                </div>
                <Card.Body className={`${styles.buttonAnimate} p-0`}>
                  <Card.Title>
                    {decodeHtml(blog[0]?.attributes?.Title)}
                  </Card.Title>
                  <Card.Text>
                    {decodeHtml(blog[0]?.attributes?.Content)
                      ?.replace(/<\/?[^>]+(>|$)/g, "")
                      ?.substring(0, 100)}
                    ...
                  </Card.Text>
                  <Button className="animated-button res-read">Read More</Button>
                </Card.Body>
              </Card>
            </a>
          ) : null}
        </Col>
        {width > 1129 ? (
          <Col lg={7} md={12} className="">
            <Row className="pl-2">
              {blog.slice(1, 6).map((blog: any, index: number) => (
                <Col lg={6} md={6} sm={12} style={{ gap: '10px' }} key={index}>

                  <BlogCard key={index} blog={blog} width={width} isMobile={isMobile} />
                </Col>
              ))}
            </Row>
          </Col>
        ) : (
          <Col lg={6} md={12} className="col-class d-flex flex-column" style={{ rowGap: '12px' }}>
            {" "}
            {blog.slice(0, 4).map((blog: any, index: number) => (
              <BlogCard key={index} blog={blog} width={width} classNameMargin={index !== 3 ? '' : 'mb-0'} isMobile={isMobile} />
            ))}
          </Col>
        )}
      </Row>
      <Button className=' float-left explore-more-btn' onClick={() => { router.push('/resources/blog/') }}>All Resources</Button>

    </Container>
    </div>
  ) : (
    <></>
  );
};

export default Resources;
